// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"1015a9bf","185":"c73286ce","453":"209697e4","511":"68241607","798":"8c84354f","833":"825aa57f"}[chunkId] + ".chunk.js";
};